export default [
    {
        title: '货件编号',
        dataIndex: 'cargoNo',
        key: 'cargoNo',
        scopedSlots: {
            customRender: 'cargoNo'
        },
    }
]